export function getStatusColor(status) {
  if (!status) return 'grey';

  const normalized = status.toLowerCase();
  const colorMap = {
    'complete': 'success',
    'completed': 'success',
    'error': 'error',
    'failed': 'error',
    'processing': 'primary',
    'running': 'primary',
    'queued': 'warning',
    'awaiting_selection': 'info',
    'awaiting': 'info',
    'skipped': 'grey'
  };

  return colorMap[normalized] || 'grey';
}

export function getStatusIcon(status) {
  if (!status) return 'mdi-help-circle';

  const normalized = status.toLowerCase();
  const iconMap = {
    'complete': 'mdi-check-circle',
    'completed': 'mdi-check-circle',
    'error': 'mdi-alert-circle',
    'failed': 'mdi-alert-circle',
    'processing': 'mdi-loading mdi-spin',
    'running': 'mdi-loading mdi-spin',
    'queued': 'mdi-clock-outline',
    'awaiting_selection': 'mdi-help-circle-outline',
    'awaiting': 'mdi-help-circle-outline',
    'skipped': 'mdi-skip-next'
  };

  return iconMap[normalized] || 'mdi-help-circle';
}

export function getMessageType(status) {
  if (!status) return 'info';

  const normalized = status.toLowerCase();

  if (normalized === 'complete' || normalized === 'completed') {
    return 'success';
  }

  if (normalized === 'error' || normalized === 'failed') {
    return 'error';
  }

  if (normalized === 'processing' || normalized === 'running') {
    return 'info';
  }

  if (normalized === 'queued') {
    return 'warning';
  }

  return 'info';
}

export function getStatusText(status) {
  if (!status) return 'Unknown';

  const normalized = status.toLowerCase();
  const textMap = {
    'complete': 'Complete',
    'completed': 'Completed',
    'error': 'Error',
    'failed': 'Failed',
    'processing': 'Processing',
    'running': 'Running',
    'queued': 'Queued',
    'awaiting_selection': 'Awaiting Selection',
    'awaiting': 'Awaiting',
    'skipped': 'Skipped'
  };

  return textMap[normalized] || status.charAt(0).toUpperCase() + status.slice(1);
}

export function isTerminalStatus(status) {
  if (!status) return false;

  const normalized = status.toLowerCase();
  const terminalStates = ['complete', 'completed', 'error', 'failed', 'awaiting_selection'];

  return terminalStates.includes(normalized);
}

export function isSuccessStatus(status) {
  if (!status) return false;

  const normalized = status.toLowerCase();
  return normalized === 'complete' || normalized === 'completed';
}

export function isFailureStatus(status) {
  if (!status) return false;

  const normalized = status.toLowerCase();
  return normalized === 'error' || normalized === 'failed';
}

export function isProcessingStatus(status) {
  if (!status) return false;

  const normalized = status.toLowerCase();
  return normalized === 'processing' || normalized === 'running' || normalized === 'queued';
}
